import { createSelector } from 'reselect';
import { filter, keyBy } from 'lodash/fp';
import { Selector } from 'react-redux';
import hash from 'object-hash';
import { ActionLogItem, ApplicationState } from '@mews-commander/types';
import { createAction, createReducer } from '@mews/framework';
import { getStringProp } from '@mews/fp';
import { ActionLogItem as ActionLogItemDataType } from '@mews-commander/data-access';
import { sortByDescending } from '@mews-commander/utils';
import prefix from '../prefix';
import moduleSelector from '../selector';
import { Entities } from './utils';

export const NAME = 'actionLogItems';

const ACTION_LOG_ITEMS_LOADED = prefix('ACTION_LOG_ITEMS_LOADED');

export const setActionLogItems = (entities: ActionLogItemDataType[]) =>
    createAction(ACTION_LOG_ITEMS_LOADED, { entities });

export const getActionLogItems: Selector<ApplicationState, Entities<ActionLogItem>> = createSelector(
    moduleSelector,
    (state) => state[NAME]
);

export const getActionLogItemsByEntityOrOwnerId = createSelector(
    getActionLogItems,
    getStringProp('entityId'),
    (actionLogItems, entityId) =>
        filter((item) => item.entityId === entityId || item.ownerIds.includes(entityId), actionLogItems)
);

// @ts-expect-error
export const getSortedActionLogItemsByEntityOrOwnerId: Selector<
    ApplicationState,
    ActionLogItem[],
    { entityId: string }
> = createSelector(getActionLogItemsByEntityOrOwnerId, sortByDescending('createdUtc'));

export const actionLogItemsReducer = createReducer(
    {},
    {
        [ACTION_LOG_ITEMS_LOADED]: (state: ActionLogItem[], { entities }: { entities: ActionLogItem[] }) => ({
            ...state,
            ...keyBy(hash, entities),
        }),
    }
);
